// extracted by mini-css-extract-plugin
module.exports = {"alert":"alert-module--alert--1IILb","message":"alert-module--message--EEp6f"};